"use client";

import { Children, FC, PropsWithChildren, useMemo } from "react";

import { BuilderContent, isEditing } from "@builder.io/sdk-react";

import { Column, Row } from "@jti/ui/components/Row";

import { Content } from "@/libs/builder/Content";
import { isReferenceObjectWithValue } from "@/libs/builder/tools/isReferenceObjectWithValue";

import { FaqResultsContainerProps } from "./FaqResultsContainer.builder";

import styles from "./FaqResultsContainer.module.scss";

export const FaqResultsContainer: FC<
  PropsWithChildren<FaqResultsContainerProps>
> = ({ children, sidebar, searchbar }) => {
  const sidebarContent = useMemo(() => {
    if (sidebar && isReferenceObjectWithValue<BuilderContent>(sidebar)) {
      return sidebar.value;
    }
    return null;
  }, [sidebar]);

  const searchBarContent = useMemo(() => {
    if (searchbar && isReferenceObjectWithValue<BuilderContent>(searchbar)) {
      return searchbar.value;
    }
    return null;
  }, [searchbar]);

  const hasChildren = Children.count(children) > 0;
  return (
    <Row>
      {searchBarContent && (
        <Column xs={12} className={styles.searchRow}>
          <Content model={"faq-search"} content={searchBarContent} />
        </Column>
      )}
      <Column md={8} className={styles.contentColumn}>
        {!hasChildren && isEditing() && <p>Drag and drop component here</p>}
        {children}
      </Column>
      <Column md={4}>
        {sidebarContent && (
          <Content model={"faq-sidebar"} content={sidebarContent} />
        )}
      </Column>
    </Row>
  );
};
